{ forEach } = require 'lodash'

module.exports =

  parse: (str, sep = '&', eq = '=') ->
    obj = {}
    forEach String(str).split(sep), (param) ->
      [key, val] = param.split eq
      obj[key] = val
    obj



// WEBPACK FOOTER //
// ./webpack/requires/components/query-string.coffee